<!-- TEMPLATE -->
<template>
  <div class="card" v-if="true">
    <div class="card-header">
      <h5 class="card-category">Auth0 IP reputation widget</h5>
    </div>
    <div class="card-body">
      <!--
							<v-text-field
						label="IP"
						outlined
						v-model="ip"
						color="white"
						:append-outer-icon="'mdi-send-clock'"
						@click:append-outer="checkIP()"
						></v-text-field>
						-->

      <h4 class="card-title" id="auth0" v-if="ipReputationScore != null">
        <img src="@/assets/img/auth0.png" width="30" />
        IP reputation is
        <v-chip
          :color="getReputationColor(ipReputationScore)"
          text-color="white"
        >
          {{ ipReputationScore }}</v-chip
        >
      </h4>

      <h4 class="card-title" id="auth0" v-else>
        <img src="@/assets/img/auth0.png" width="30" />
        <v-chip>N/A</v-chip>
      </h4>

      <div></div>
    </div>

    <v-expansion-panels :readonly="readonly" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header
          >Auth IP Reputation full response</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <vue-json-pretty
            :path="'res'"
            :data="ipReputationFull"
            :highlightMouseoverNode="ipReputationHighlightMouseoverNode"
          >
          </vue-json-pretty>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<!-- SCRIPT -->
<script>
import VueJsonPretty from "vue-json-pretty";
export default {
  name: "Auth0IPReputationCheck",
  data: function () {
    return {
      ipReputationHighlightMouseoverNode: "",
    };
  },
  created() {
    //this.checkIP()
  },
  methods: {
    getReputationColor: function (number) {
      if (number == "n/a") return "grey";
      else if (number == 0) return "green";
      else if (number > -3) return "orange";
      else return "red";
    },
  },
  components: {
    VueJsonPretty,
  },
  props: ["ipReputationScore", "ipReputationFull"],
};
</script>

<!-- Style -->
<style>
</style>